import { useLocaleStore } from '@/stores/localeStore';

export const useDisplayNames = () => {
    const { displayLocale } = useLocaleStore();
    if (!displayLocale) {
        return;
    }
    const displayNameFormatter = new Intl.DisplayNames([displayLocale], {
        type: 'region',
    });

    return (name: string) => displayNameFormatter.of(name);
};
